interface BadgeProps {
    variant: 'vac' | 'game' | 'no-ban' | 'smurf' | 'smurf-recent';
    children: React.ReactNode;
    title?: string;
    strength?: number;
}

function Badge({variant, children, title, strength}: BadgeProps) {
    const className = variant === 'vac' ? 'badge-vac' : 
                      variant === 'game' ? 'badge-game' : 
                      variant === 'smurf-recent' ? 'badge-smurf-recent' : 
                      variant === 'smurf' ? 'badge-smurf' : 
                      'badge-no-ban';
    return (
        <span
            className={className}
            title={title}
            style={strength === undefined ? undefined : {
                filter: `brightness(${0.85 + strength * 0.15}) saturate(${0.7 + strength * 0.6})`,
            }}
        >
            {children}
        </span>
    );
}

export default Badge;
